// Usage
const urlBase = `${location.origin}/themes/custom/aguila/sources-loyalty/dist/assets/images`;
var imageUrls = [
  '/menu/estadio.png',
  '/menu/camerino.png',
  '/menu/futbolin.png',
  '/menu/icon_start.png',
  '/menu/premios.png',
  '/menu/predicciones.png',
  '/menu/tada.png',
  '/menu/notice.png',
  '/bg/bg_menu1.jpeg',
  '/bg/whiteLeft.png',
  '/bg/whiteCenter.png',
  '/bg/whiteLeft.png',
  '/popups/bg-items02.png',
  '/popups/points.png',
  '/popups/bg-ola.png',
  '/bg/bg_blue_small.png',
  '/bg/bg_red_text.png',
  '/bg/bg_blue_esquina.png',
  '/bg/bkQuestions.png',
  '/bg/iconsQuestions.png',
];

export function prefetchImages() {
  imageUrls.forEach(function(url) {
    const img = new Image();
    img.src = `${urlBase}${url}`;
  });
}

